import { ApexOptions } from "apexcharts";
import { ukoTheme } from "../../../theme";

const theme = ukoTheme();
export const chartColors = [
  theme.palette.primary.main,
  "#D37B13",
  "#5F1ED9",
  "#0A2240",
  "#AA0000",
  "#5F1ED9",
  "#80c7fd",
  "#008FFB",
  "#80f1cb",
  "#00E396",
  "#00c853",
  "#00e676",
  "#f0f4c3",
  "#827717",
  "#fbc02d",
  "#f57f17",
  "#ffab91",
  "#f4511e",
  "#d7ccc8",
  "#8d6e63",
  "#3e2723",
  "#9e9e9e",
  "#424242",
  "#b0bec5",
  "#546e7a",
  "#FF8F00",
  "#C6FF00",
  "#0091EA",
  "#FF80AB",
  "#00B8D4",
  "#FF4081",
  "#FF8A80",
  "#FF6D00",
  "#00897B",
  "#A0522D",
  "#76608A",
  "#825A2C",
];

export const covertFigure = (figure: number): string => {
  if (figure >= 1000000000) {
    return `${(figure / 1000000000).toFixed(2)}B`;
  } else if (figure >= 1000000) {
    return `${(figure / 1000000).toFixed(2)}M`;
  } else if (figure >= 1000) {
    return `${(figure / 1000).toFixed(2)}K`;
  }
  return figure.toString();
};

export const getChartOptions = (
  getXAxis: any,
  yAxixText?: any,
  columnWidth?: number | null,
  stroke?: number | null,
  colors?: any[],
) => {
  const chartOptions: ApexOptions = {
    chart: {
      background: "transparent",
      toolbar: { show: false },
      id: "",
    },
    colors: colors || chartColors,
    dataLabels: {
      enabled: false,
    },
    stroke: {
      curve: "smooth",
      width: stroke || 0,
    },
    xaxis: {
      categories: getXAxis(),
    },
    yaxis: {
      title: {
        text: yAxixText || "",
      },
      show: true,
      labels: {
        show: true,
        formatter: function (val: any) {
          return covertFigure(val);
        },
      },
    },
    responsive: [
      {
        breakpoint: 550,
        options: {
          chart: {
            height: 350,
          },
          plotOptions: {
            bar: {
              horizontal: true,
            },
          },
          xaxis: {
            labels: { show: false },
          },
          yaxis: {
            show: true,
            labels: {
              style: {
                colors: theme.palette.text.disabled,
                fontFamily: theme.typography.fontFamily,
                fontWeight: 500,
              },
              formatter: function (val: any) {
                return covertFigure(val);
              },
            },
          },
        },
      },
    ],
    plotOptions: {
      bar: {
        horizontal: false,
        borderRadius: 5,
        borderRadiusApplication: "end",
        borderRadiusWhenStacked: "last",
        columnWidth: columnWidth || 20,
      },
    },
  };
  return chartOptions;
};
